module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"cancel":"キャンセル"}}')
  delete Component.options._Ctor
}
